import { sectionedPanelStyle } from '../CampaignStyles';

export const requiredPanelStyle = {
    ...sectionedPanelStyle,
    padding: '11px 188px 9.5px 188px'
};

export const goalPanelStyle = {
    ...sectionedPanelStyle,
    height: 159
};

export const optionalPanelStyle = {
    ...sectionedPanelStyle,
    paddingBottom: 40
};

export const discountPanelStyle = {
    ...sectionedPanelStyle,
    padding: '11px 230px 25px 230px',
    display: 'flex',
    flexDirection: 'column'
};

export const contactPanelStyle = {
    padding: '11px 230px 25px 230px',
    display: 'flex',
    justifyContent: 'space-between'
};

export const notesPanelStyle = {
    padding: '11px 230px 25px 230px',
    display: 'flex',
    justifyContent: 'space-between'
};

export const historyPanelStyle = {
    padding: '11px 230px 25px 230px',
    display: 'flex',
    justifyContent: 'space-between'
};

export const commercialPanelStyle = {
    ...sectionedPanelStyle,
    padding: '11px 188px 9.5px 188px'
};

export const valuePotPanelStyle = {
    ...sectionedPanelStyle,
    padding: '11px 230px 17px 230px'
};

export const referenceNumbersPanelStyle = {
    ...sectionedPanelStyle,
    padding: '17px 230px 22px 230px'
};

export const panelTitleStyle = {
    fontSize: 16,
    fontWeight: 500
};

export const tableCellStyle = {
    fontSize: 13
};

export const cellPadding = '8px 42px 0px 42px';

export const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 5
};

export const poNumberLabelStyle = {
    ...labelStyle,
    marginRight: -64
};

export const monthlyPoNumberLabelStyle = {
    ...labelStyle,
    color: 'rgb(65, 65, 65)'
};

export const inputStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 40,
    outline: 'none',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600
};
export const inputweekStyle = {
    boxSizing: 'border-box',
    width: 52,
    height: 40,
    outline: 'none',
    padding: '0 10px 0 2px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600
};
export const statusInputStyle = {
    ...inputStyle,
    outline: 'none'
};

export const poNumberInputStyle = {
    ...inputStyle,
    width: 135,
    zIndex: 25
};

export const descriptionInputStyle = {
    ...inputStyle,
    height: 73
};

export const compactTableInputStyle = {
    ...inputStyle,
    fontSize: 15,
    fontWeight: 500
};

export const poNumberMonthlySelectStyle = {
    ...inputStyle,
    width: 137,
    zIndex: 25
};

export const missingFieldsStyle = {
    boxSizing: 'border-box',
    height: 44,
    width: 467,
    border: '1px solid #436F04',
    borderRadius: 6,
    backgroundColor: '#E9FDCC',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    paddingTop: 12
};

export const favouritesTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const fixedInfoTextStyle = {
    color: '#8A8A8A',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const isFavouriteContainerStyle = (disabled) => {
    return {
        display: 'flex',
        cursor: disabled ? 'default' : 'pointer',
        paddingRight: 60
    };
};

export const oneRequiredContainerStyle = {
    display: 'flex'
};

export const autoflexRowStyle = {
    width: 1456,
    marginLeft: 190
};

export const pageHeadingAlignmentStyle = {
    marginLeft: 233,
    marginTop: 21,
    marginBottom: -9,
    width: 'unset'
};

export const descriptionContainerStyle = {
    display: 'flex'
};

export const jcnSurveyContainerStyle = {
    display: 'flex'
};

export const monthlyPoListContainerStyle = {
    boxSizing: 'border-box',
    height: 321,
    width: 282,
    border: '1px solid #CCCCCC',
    borderRadius: '0 0 15px 15px',
    backgroundColor: '#FFFFFF',
    boxShadow: '3px 2px 11px 0 rgba(0,0,0,0.33)'
};

export const monthlyPoListTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold'
};

export const monthlyPoListTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500
};

export const monthlyPoListTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const monthlyPoListPeriodCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 34,
        border: '1px solid #CCCCCC',
        backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF',
        paddingLeft: 10
    };
};

export const monthlyPoListNumberCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 34,
        border: `1px solid ${i % 2 === 0 ? '#D7D7D7' : '#CCCCCC'}`,
        backgroundColor: i % 2 === 0 ? '#FFFAE5' : '#FFFDF4',
        paddingRight: 7,
        textAlign: 'right'
    };
};

export const applyButtonStyle = {
    boxSizing: 'border-box',
    height: 34,
    width: 96,
    border: '1px solid #FDA900',
    borderRadius: 5,
    backgroundColor: '#FAA800',
    color: '#000000',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 'bold'
};

export const monthlyPoInputStyle = (disabled) => {
    return {
        width: '100%',
        padding: '0px 12px',
        border: '1px solid rgb(215, 215, 215)',
        borderRadius: 5,
        cursor: disabled ? 'default' : 'pointer',
        resize: 'vertical',
        contain: 'strict',
        display: 'block',
        textAlign: 'left',
        backgroundColor: disabled ? 'rgb(247, 247, 247)' : 'rgb(255, 253, 244)',
        color: 'rgb(65, 65, 65)',
        boxSizing: 'border-box',
        height: 40,
        outline: 'none',
        fontSize: 15,
        letterSpacing: '-0.3px',
        fontWeight: 600,
        marginTop: 19,
        paddingTop: 11,
        zIndex: 25
    };
};

export const monthlyPoNumberInlineStyle = {
    ...inputStyle,
    ...monthlyPoListTextStyle,
    marginLeft: 21,
    height: 29,
    width: 111
};

export const monthlyPoNumberValueStyle = (active) => {
    return {
        fontSize: 15,
        letterSpacing: -0.3,
        fontWeight: 600,
        color: active ? '#414141' : '#C0C0C0'
    };
};

export const rationalDescriptionStyle = {
    width: 1532,
    height: 75,
    padding: '0px 8px',
    border: '1px solid #dadada',
    borderRadius: 4,
    backgroundColor: '#fffdf4',
    backgroundSize: 'cover',
    fontFamily: 'Roboto',
    fontSize: 14,
    color: '#121212',
    textDecoration: 'none solid rgb(18, 18, 18)'
}